export enum PersonTypeKey {
  ADULT_GUEST = "ADULT_GUEST",
  ADULT_MEMBER = "ADULT_MEMBER",
  EMERGENCY_CONTACT = "EMERGENCY_CONTACT",
  FRIEND = "FRIEND",
  JP_INSTRUCTOR = "JP_INSTRUCTOR",
  JUNIOR_MEMBER = "JUNIOR_MEMBER",
  JUNIOR_PARENT = "JUNIOR_PARENT",
  ORGANIZATION = "ORGANIZATION",
  ORGANIZATION_CONTACT = "ORGANIZATION_CONTACT",
  UAP_MEMBER = "UAP_MEMBER",
}
